import { Navigate, Outlet } from "react-router-dom";
import { clearAccessToken, getAccessToken } from "../common";

export const isAuthenticated = () => {
  return !!getAccessToken();
};

const PrivateRoute = () => {
  try {
    const authenticated = isAuthenticated();

    if (!authenticated) {
      clearAccessToken();
      localStorage.clear();
      return <Navigate replace to="/login" />;
    }

    // Prevent inactive users from accessing private (dashboard) routes
    const data = localStorage.getItem("userData");
    if (data) {
      try {
        const userData = JSON.parse(data);
        if (userData?.isActive === false || userData?.isActive === 0) {
          return <Navigate replace to="/approval" />;
        }
      } catch (e) {
        console.error("Error parsing user data in PrivateRoute:", e);
        clearAccessToken();
        localStorage.clear();
        return <Navigate replace to="/login" />;
      }
    }

    return <Outlet />;
  } catch (error) {
    console.error("Error in PrivateRoute:", error);
    clearAccessToken();
    localStorage.clear();
    return <Navigate replace to="/login" />;
  }
};

const AdminRoute = () => {
  if (!isAuthenticated()) {
    clearAccessToken();
    return <Navigate replace to="/login" />;
  }

  try {
    let data = localStorage.getItem("userData");
    if (!data) {
      clearAccessToken();
      localStorage.clear();
      return <Navigate replace to="/login" />;
    }
    
    const userRole = JSON.parse(data);
    if (userRole?.role === "user") {
      return <Navigate replace to="/student" />;
    }
  } catch (error) {
    console.error("Error parsing user data:", error);
    clearAccessToken();
    localStorage.clear();
    return <Navigate replace to="/login" />;
  }

  return <Outlet />;
};

export { PrivateRoute, AdminRoute };
